import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import ImgFallback from "@/components/ImgFallback";
import { ShieldCheck, Clock, Info, ArrowLeft } from "@phosphor-icons/react";

export default function KutzPass() {
  const { bid } = useParams();
  const [pass, setPass] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get(`/bookings/${bid}/pass`).then((r) => setPass(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Unable to load Pass"));
  }, [bid]);

  if (err) return <div className="max-w-md mx-auto px-6 py-16 text-cream/70" data-testid="pass-error">{String(err)}</div>;
  if (!pass) return <div className="max-w-md mx-auto px-6 py-16 text-cream/50" data-testid="pass-loading">Loading Pass…</div>;

  return (
    <div className="max-w-md mx-auto px-5 pt-6 pb-24" data-testid="kutz-pass-page">
      <Link to="/upcoming" className="flex items-center gap-2 text-cream/70 hover:text-gold" data-testid="pass-back">
        <ArrowLeft size={14} /><span className="text-xs uppercase tracking-[0.2em]">Upcoming</span>
      </Link>
      <p className="overline mt-6 mb-2">KUTZ Pass</p>
      <h1 className="font-display text-4xl tracking-tighter">{pass.studio_name}</h1>
      <p className="text-cream/70 mt-1 text-sm">{pass.service_name}</p>
      <p className="text-xs text-cream/60 mt-1 flex items-center gap-1">
        <Clock size={12} weight="fill" color="#C5A059" />
        {new Date(pass.start_time).toLocaleString(undefined, { weekday: "long", day: "numeric", month: "short", hour: "numeric", minute: "2-digit" })}
      </p>

      <div className="mt-8 border border-gold/40 bg-gold/5 p-6 flex flex-col items-center" data-testid="pass-qr">
        <ImgFallback src={pass.qr_data_url} alt="KUTZ Pass QR" className="w-64 h-64 bg-white p-3" />
        <p className="mt-4 text-[10px] uppercase tracking-[0.25em] text-cream/60">Fallback code</p>
        <p className="font-display text-2xl tracking-[0.3em] text-gold" data-testid="pass-code">{pass.pass_code}</p>
      </div>

      <div className="mt-6 border border-cream/10 p-4 flex items-start gap-3">
        <ShieldCheck size={18} color="#C5A059" weight="fill" />
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] text-gold">Booking-specific</p>
          <p className="text-xs text-cream/70 mt-1">This QR is tied to this appointment only. Do not share.</p>
        </div>
      </div>
      <div className="mt-3 border border-cream/10 p-4 flex items-start gap-3">
        <Info size={18} color="#C5A059" />
        <p className="text-xs text-cream/70">Show this at arrival. Your Professional scans and location proximity confirms check-in.</p>
      </div>
    </div>
  );
}
